<template>
  <div id="serambi">
    <div></div>
  </div>
</template>

<script>
export default {
  mounted() {
    (function(w, d, s, u) {
      w.RocketChat = function(c) {
        w.RocketChat._.push(c);
      };
      w.RocketChat._ = [];
      w.RocketChat.url = u;
      var h = d.getElementsByTagName(s)[0],
        j = d.createElement(s);
      j.async = true;
      j.src =
        'https://chat.masjed.id/livechat/rocketchat-livechat.min.js?_=201903270000';
      h.parentNode.insertBefore(j, h);
    })(
      window,
      document,
      'script',
      'https://chat.masjed.id/livechat?mode=popout'
    );
    RocketChat(function() {
      this.initialize({
        theme: {
          color: '#28a745',
          fontColor: '#FFFFFF',
          iconColor: '#1d74f5',
          title: 'Konsultasi Usaha Serambi',
          offlineTitle: 'Service is offline',
        },
        department: 'usahaserambi',
        language: 'id',
      });
      RocketChat(function() {
        this.maximizeWidget();
      });
    });
  },
};
</script>
